var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pagination" },
    [
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-sizes": _vm.pageSizes,
          "page-size": _vm.pageSize,
          total: _vm.total,
          layout: _vm.layout,
          background: _vm.background,
          disabled: _vm.disabled,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }